import { useCallback } from "react";

export const useInput = ({ onChange, setValue }) => {
  const onChangeInput = useCallback(
    (e) => {
      setValue?.(e.target.value);
      onChange(e);
    },
    [onChange, setValue]
  );
  return {
    onChangeInput,
  };
};
